import { Container, Row, Col } from "react-bootstrap";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import React from "react";
import HubSpotAuth from "./components/HubSpotAuth";
import AuthSuccess from "./components/AuthSuccess";


function App() {
    return (
        <>

        <Container className="appContainer">
            <Row>
                <Col>

                    <UserAuthContextProvider>
                        <Routes>
                            <Route path="/auth" element={<ProtectedRoute><Home /></ProtectedRoute>}/>
                            <Route path="/" element={<Login />}/>
                            <Route path="/signup" element={<Signup />}/>
                            <Route path="/auth-hubspot" element={<HubSpotAuth />}/>
                            <Route path="/auth-success" element={<AuthSuccess />}/>
                        </Routes>
                    </UserAuthContextProvider>
                </Col>
            </Row>
        </Container>
            </>
    );
}

export default App;